/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSubscriptionDetails model module.
 * @module model/AqaSubscriptionDetails
 * @version v0
 */
export default class AqaSubscriptionDetails {
  /**
   * Constructs a new <code>AqaSubscriptionDetails</code>.
   * @alias module:model/AqaSubscriptionDetails
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSubscriptionDetails</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSubscriptionDetails} obj Optional instance to populate.
   * @return {module:model/AqaSubscriptionDetails} The populated <code>AqaSubscriptionDetails</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSubscriptionDetails();
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('referenceValid'))
        obj.referenceValid = ApiClient.convertToType(data['referenceValid'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} active
 */
AqaSubscriptionDetails.prototype.active = undefined;

/**
 * @member {Boolean} referenceValid
 */
AqaSubscriptionDetails.prototype.referenceValid = undefined;

